import { render, staticRenderFns } from "./UpdateShiftsPopup.vue?vue&type=template&id=e843c6e4"
import script from "./UpdateShiftsPopup.vue?vue&type=script&lang=ts"
export * from "./UpdateShiftsPopup.vue?vue&type=script&lang=ts"
import style0 from "./UpdateShiftsPopup.vue?vue&type=style&index=0&id=e843c6e4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports